import { Octopus } from '../api';

type EntityUdoRelationshipMap = Partial<
  Record<Octopus.EntityCode, Octopus.EntityCode[]>
>;

// Contains defined business rules related to UDO relationships that are used across the application.
const ENTITY_UDO_MAPPINGS: EntityUdoRelationshipMap = {
  [Octopus.AbEntryEntityCode]: [
    Octopus.DataHubInsurancePolicyEntityCode,
    Octopus.DataHubAccountEntityCode,
  ],
};

export function getRelatedUdoEntities(
  entity: Octopus.EntityCode,
): Octopus.EntityCode[] {
  return ENTITY_UDO_MAPPINGS[entity] ?? [];
}
